<template>
  <header>
    <nav class="navbar navbar-expand-md" aria-label="Main Navigation">
      <div class="container-fluid align-items-sm-center">
        <router-link :to="{ name: 'Home' }" class="navbar-brand">
          <img
            src="https://snippcheck.blob.core.windows.net/files/Suntory_2008985_JimBeamBigGameFootballSweepsQ4/logo.png"
            class="img-fluid" style="max-width: 100px;" alt="logo">
        </router-link>

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-Nav"
          @click="toggleCollapse" aria-controls="navbar-Nav" :aria-expanded="isCollapsed ? 'true' : 'false'"
          aria-label="Toggle navigation" :class="{ active: isCollapsed }" v-if="!$route.meta.hideNav"></button>

        <div :class="{ show: isCollapsed }" class="collapse navbar-collapse justify-content-end my-2" id="navbar-Nav"
          v-if="!$route.meta.hideNav">
          <ul class="navbar-nav w-100 justify-content-end" data-gtm-menu-type="header">
            <li class="nav-item" data-gtm-menu="Home">
              <router-link :to="{ name: 'Home' }" class="nav-link" @click="closeMenu">
                {{ $t('Header.HomeTab') }}
              </router-link>
            </li>
            <li class="nav-item" data-gtm-menu="Enter">
              <router-link :to="{ name: 'Enter' }" class="nav-link" @click="closeMenu">
                {{ $t('Header.UploadTab') }}
              </router-link>
            </li>
            <li class="nav-item" data-gtm-menu="FAQ">
              <router-link :to="{ name: 'FAQ' }" class="nav-link" @click="closeMenu">
                {{ $t('Header.SupportTab') }}
              </router-link>
            </li>
          </ul>
        </div>

      </div>
    </nav>
  </header>

  <banner></banner>
</template>


<script>
import banner from '../UI/Banner.vue';
import { useI18n } from 'vue-i18n';
import { ref, watch, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export default {
  components: { banner },
  setup() {
    const { locale } = useI18n();
    const currentLang = ref(locale.value);
    const isCollapsed = ref(false); // ✅ Define state for toggle
    const route = useRoute();
    const router = useRouter();

    const toggleCollapse = () => {
      isCollapsed.value = !isCollapsed.value;
      handleBodyScroll();
    };

    const closeMenu = () => {
      isCollapsed.value = false;
      handleBodyScroll();
    };

    const handleBodyScroll = () => {
      if (isCollapsed.value) {
        document.body.classList.add("no-scroll");
      } else {
        document.body.classList.remove("no-scroll");
      }
    };

    const changeLanguage = async (lang) => {
      if (currentLang.value === lang) return;

      let newPath = route.fullPath;

      if (lang === 'en') {
        // Strip the /fr prefix safely
        newPath = newPath.replace(/^\/fr(\/|$)/, '/');
      } else {
        // Prepend /fr prefix
        if (!newPath.startsWith('/fr')) {
          newPath = '/fr' + (newPath === '/' ? '' : newPath);
        }
      }

      await router.push({ path: newPath });

      currentLang.value = lang;
      //injectGTM();
    };

    watch(locale, (newLocale) => {
      currentLang.value = newLocale;
    });

    onMounted(() => {
      //injectGTM();
    });

    /* const injectGTM = () => {
       const gtmId = t('gtmId');
       if (!gtmId) return;
    
       document.querySelectorAll("[data-gtm]").forEach(el => el.remove());
    
       const script = document.createElement("script");
       script.setAttribute("data-gtm", gtmId);
       script.innerHTML = `
         (function (w, d, s, l, i) {
           w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
           var f = d.getElementsByTagName(s)[0],
               j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; 
           j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; 
           f.parentNode.insertBefore(j, f);
         })(window, document, 'script', 'dataLayer', '${gtmId}');
       `;
       document.head.appendChild(script);
    
       const noscript = document.createElement("noscript");
       noscript.setAttribute("data-gtm", gtmId);
       noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
       document.body.prepend(noscript);
     };*/

    return { currentLang, changeLanguage, isCollapsed, toggleCollapse, closeMenu };
  },
};
</script>
